import Vue from "vue";

const previewMeasureStore = {
	plugins: [],
	state: {},
	mutations: {
		updatePreviewingMeasure(state, { measure: measure }) {
			Vue.set(state, "previewingMeasure", null);
			if (measure !== null) {
				setTimeout(function () {
					Vue.set(state, "previewingMeasure", measure);
				}, 1);
			}
			return state;
		},
	},

	getters: {
		previewingMeasure: (state, getters) => () => {
			return state.previewingMeasure;
		},
	},

	actions: {},
};

export default previewMeasureStore;
